import React, { useState, useEffect, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import toast from "react-hot-toast";
import { documentsAPI, healthAPI } from "../services/api";

/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */

const FILE_ICONS = { pdf:"📕", docx:"📘", txt:"📄", md:"📝", csv:"📊", html:"🌐" };

export default function Sidebar({ documents, setDocuments, systemStatus, setSystemStatus }) {
  const [uploading, setUploading] = useState(false);
  const [urlInput, setUrlInput] = useState("");
  const [ingestingUrl, setIngestingUrl] = useState(false);

  useEffect(() => {
    fetchDocuments(); checkHealth();
    const interval = setInterval(checkHealth, 15000);
    return () => clearInterval(interval);
  }, []);

  const fetchDocuments = async () => { try { const r = await documentsAPI.list(); setDocuments(r.data); } catch {} };
  const checkHealth = async () => { try { const r = await healthAPI.check(); setSystemStatus(r.data); } catch {} };

 const onDrop = useCallback(async (files) => {
    // eslint-disable-next-line
    for (const file of files) {
      setUploading(true);
      try { const r = await documentsAPI.upload(file); setDocuments(p => [...p, r.data]); toast.success(`Indexed: ${file.name}`); }
      catch { toast.error(`Failed: ${file.name}`); }
      finally { setUploading(false); }
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
      "text/plain": [".txt"], "text/markdown": [".md"],
      "text/csv": [".csv"], "text/html": [".html"],
    },
    multiple: true,
  });

  const handleURL = async () => {
    if (!urlInput.trim()) return;
    setIngestingUrl(true);
    try { const r = await documentsAPI.ingestURL(urlInput.trim()); setDocuments(p => [...p, r.data]); toast.success(`Indexed`); setUrlInput(""); }
    catch { toast.error("Failed to ingest URL"); }
    finally { setIngestingUrl(false); }
  };

  const handleDelete = async (id) => {
    try { await documentsAPI.delete(id); setDocuments(p => p.filter(d => d.id !== id)); toast.success("Removed"); }
    catch { toast.error("Failed"); }
  };

  const ext = (name) => name.split(".").pop()?.toLowerCase() || "txt";

  return (
    <aside style={{ width: "270px", flexShrink: 0, display: "flex", flexDirection: "column", background: "var(--bg)", borderRight: "1px solid var(--border)", height: "100vh" }}>
      {/* Logo */}
      <div style={{ padding: "16px", borderBottom: "1px solid var(--border)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div style={{ width: "34px", height: "34px", borderRadius: "10px", background: "var(--accent-bg)", border: "1px solid var(--accent-border)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="#14b88e"/></svg>
          </div>
          <div>
            <div style={{ fontSize: "15px", fontWeight: 700, color: "var(--text-1)" }}>RAG System</div>
            <div style={{ fontSize: "10px", color: "var(--accent)", fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase" }}>Adaptive Retrieval</div>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: "16px" }}>
        {/* Upload */}
        <div {...getRootProps()} style={{ border: `2px dashed ${isDragActive ? "var(--accent)" : "var(--border)"}`, borderRadius: "12px", padding: "24px 16px", textAlign: "center", cursor: "pointer", background: isDragActive ? "var(--accent-bg)" : "transparent", transition: "all 0.2s" }}>
          <input {...getInputProps()} />
          {uploading ? (
            <div style={{ color: "var(--accent)", fontSize: "13px" }}>Processing...</div>
          ) : (
            <>
              <div style={{ marginBottom: "8px" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" style={{ margin: "0 auto" }}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke={isDragActive?"#14b88e":"#484f58"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
              <div style={{ fontSize: "13px", fontWeight: 600, color: "var(--text-1)", marginBottom: "4px" }}>Upload Document</div>
              <div style={{ fontSize: "11px", color: "var(--text-3)" }}>PDF, DOCX, TXT, MD, CSV, HTML</div>
            </>
          )}
        </div>

        

        {/* Document list */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "8px" }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="#484f58" strokeWidth="2"/><path d="M3 9h18M9 21V9" stroke="#484f58" strokeWidth="2"/></svg>
            <span style={{ fontSize: "11px", fontWeight: 600, color: "var(--text-3)", textTransform: "uppercase", letterSpacing: "0.08em" }}>Documents ({documents.length})</span>
          </div>

          {documents.length === 0 ? (
            <div style={{ textAlign: "center", padding: "20px 0", color: "var(--text-3)" }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ margin: "0 auto 8px" }}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="#484f58" strokeWidth="1.5"/><path d="M14 2v6h6" stroke="#484f58" strokeWidth="1.5"/></svg>
              <div style={{ fontSize: "12px" }}>No documents yet.</div>
              <div style={{ fontSize: "11px", marginTop: "2px" }}>Upload a file or paste a URL.</div>
            </div>
          ) : (
            documents.map(doc => (
              <div key={doc.id}
                style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px", borderRadius: "8px", marginBottom: "2px", transition: "background 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.background = "var(--surface)"}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                <span style={{ fontSize: "16px", flexShrink: 0 }}>{FILE_ICONS[ext(doc.name)] || "📄"}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: "12px", fontWeight: 500, color: "var(--text-1)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{doc.name}</div>
                  <div style={{ fontSize: "11px", color: "var(--text-3)" }}>{doc.chunk_count} chunks</div>
                </div>
                <button onClick={() => handleDelete(doc.id)}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-3)", fontSize: "16px", padding: "2px 4px", borderRadius: "4px", flexShrink: 0 }}
                  onMouseEnter={e => { e.currentTarget.style.color = "#ef4444"; e.currentTarget.style.background = "rgba(239,68,68,0.1)"; }}
                  onMouseLeave={e => { e.currentTarget.style.color = "var(--text-3)"; e.currentTarget.style.background = "none"; }}>×</button>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Footer */}
      <div style={{ padding: "10px 14px", borderTop: "1px solid var(--border)" }}>
        {systemStatus && (
          <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "var(--text-3)", marginBottom: "4px" }}>
            <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: systemStatus.embedding_model ? "var(--accent)" : "#f59e0b", display: "inline-block" }} />
            {systemStatus.chunks} chunks indexed
          </div>
        )}
        <div style={{ fontSize: "11px", color: "var(--text-3)", textAlign: "center" }}>© {new Date().getFullYear()} Samantha Jessica Monis<br/>All rights reserved</div>
      </div>
    </aside>
  );
}